// extracted by mini-css-extract-plugin
export default {"wrapping":"Content_wrapping__W6vvc","content":"Content_content__tJf+o"};